import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  IconButton
} from '@mui/material';
import axios from 'axios';
import Iconify from '../components/Iconify';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import { HrconclaveListHead, HrconclaveMoreMenu } from '../sections/reports';

const TABLE_HEAD = [
  { id: 'title', label: 'Main Title', alignRight: false },
  { id: 'visionTitle', label: 'Vision Title', alignRight: false },
  { id: 'visionData', label: 'Vision Points', alignRight: false },
  { id: 'missionTitle', label: 'Mission Title', alignRight: false },
  { id: 'missionData', label: 'Mission Points', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];


export default function VisionMission() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
const [selectedVisionMission, setSelectedVisionMission] = useState(null);
const [viewModalOpen, setViewModalOpen] = useState(false);

  const [title, setTitle] = useState('');
  const [visionTitle, setVisionTitle] = useState('');
  const [visionData, setVisionData] = useState(['']);
  const [missionTitle, setMissionTitle] = useState('');
  const [missionData, setMissionData] = useState(['']);

  useEffect(() => {
    fetchVisionMission();
  }, []);

  const fetchVisionMission = async () => {
    const res = await axios.get('https://cpccbe.org/api/vision-mission/vision-mission');
    setData(res.data.data || res.data);
  };
   const handleCloseViewModal = () => {
    setViewModalOpen(false);
    setSelectedVisionMission(null);
  };

  const handleOpen = (item = null) => {
    if (item) {
      setEditingId(item._id);
      setTitle(item.title);
      setVisionTitle(item.visionTitle);
      setVisionData(item.visionData.map(v => v.li));
      setMissionTitle(item.missionTitle);
      setMissionData(item.missionData.map(m => m.li));
    } else {
      setEditingId(null);
      setTitle('');
      setVisionTitle('');
      setVisionData(['']);
      setMissionTitle('');
      setMissionData(['']);
    }
    setOpen(true);
  };

  const handleSave = async () => {
    const payload = {
  title,
  visionTitle,
  visionData: visionData
    .filter(li => li && li.trim() !== '')
    .map(li => ({ li })),

  missionTitle,
  missionData: missionData
    .filter(li => li && li.trim() !== '')
    .map(li => ({ li })),
};


    if (editingId) {
      await axios.put(`https://cpccbe.org/api/vision-mission/vision-mission/${editingId}`, payload);
    } else {
      await axios.post('https://cpccbe.org/api/vision-mission/vision-mission', payload);
    }

    fetchVisionMission();
    setOpen(false);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this record?')) {
      await axios.delete(`https://cpccbe.org/api/vision-mission/vision-mission/${id}`);
      fetchVisionMission();
    }
  };

  const renderList = (list) =>
    list.map((item, i) => (
      <Typography key={i} variant="body2">• {item.li}</Typography>
    ));

    const handleViewVisionMission = (visionMission) => {
    setSelectedVisionMission(visionMission);
    setViewModalOpen(true);
  };

  return (
    <Page title="Vision & Mission">
      <Container>
        <Stack direction="row" justifyContent="space-between" mb={4}>
          <Typography variant="h4">Vision & Mission</Typography>
          <Button variant="contained" onClick={() => handleOpen()}>
            Add New
          </Button>
        </Stack>

        <Card>
          <Scrollbar>
            <TableContainer>
              <Table>
                <HrconclaveListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map(row => (

                      <TableRow key={row._id}>
                        <TableCell padding="checkbox">
                                                    <IconButton aria-label="view" onClick={() => handleViewVisionMission(row)}>
                                                      <Iconify icon="eva:eye-fill" />
                                                    </IconButton>
                                                  </TableCell>
                        <TableCell>{row.title}</TableCell>
                        <TableCell>{row.visionTitle}</TableCell>
                        <TableCell>{renderList(row.visionData)}</TableCell>
                        <TableCell>{row.missionTitle}</TableCell>
                        <TableCell>{renderList(row.missionData)}</TableCell>
                        <TableCell>
                          <HrconclaveMoreMenu
                            onEdit={() => handleOpen(row)}
                            onDelete={() => handleDelete(row._id)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, p) => setPage(p)}
            onRowsPerPageChange={(e) => setRowsPerPage(+e.target.value)}
          />
        </Card>

        {/* Modal */}
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
          <DialogTitle>{editingId ? 'Edit' : 'Create'} Vision & Mission</DialogTitle>
          <DialogContent>
            <TextField fullWidth label="Main Title" value={title} onChange={e => setTitle(e.target.value)} />
            <TextField fullWidth label="Vision Title" sx={{ mt: 2 }} value={visionTitle} onChange={e => setVisionTitle(e.target.value)} />

            {visionData.map((v, i) => (
              <TextField
                key={i}
                fullWidth
                label={`Vision Point ${i + 1}`}
                sx={{ mt: 1 }}
                value={v}
                onChange={e => {
                  const copy = [...visionData];
                  copy[i] = e.target.value;
                  setVisionData(copy);
                }}
              />
            ))}
            <Button onClick={() => setVisionData([...visionData, ''])}>+ Add Vision Point</Button>

            <TextField fullWidth label="Mission Title" sx={{ mt: 3 }} value={missionTitle} onChange={e => setMissionTitle(e.target.value)} />

            {missionData.map((m, i) => (
              <TextField
                key={i}
                fullWidth
                label={`Mission Point ${i + 1}`}
                sx={{ mt: 1 }}
                value={m}
                onChange={e => {
                  const copy = [...missionData];
                  copy[i] = e.target.value;
                  setMissionData(copy);
                }}
              />
            ))}
            <Button onClick={() => setMissionData([...missionData, ''])}>+ Add Mission Point</Button>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={handleSave} variant="contained">Save</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={viewModalOpen} onClose={handleCloseViewModal} maxWidth="md" fullWidth>
  <DialogTitle>Vision & Mission Details</DialogTitle>

  <DialogContent>
    {selectedVisionMission && (
      <>
        {/* Main Title */}
        <TextField
          label="Main Title"
          value={selectedVisionMission.title}
          margin="dense"
          fullWidth
          variant="outlined"
          InputProps={{ readOnly: true }}
        />

        {/* Vision Section */}
        <TextField
          label="Vision Title"
          value={selectedVisionMission.visionTitle}
          margin="dense"
          fullWidth
          variant="outlined"
          InputProps={{ readOnly: true }}
        />

        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2">Vision Points</Typography>
          {selectedVisionMission.visionData?.length > 0 ? (
            selectedVisionMission.visionData.map((item, index) => (
              <Typography key={index} variant="body2">
                • {item.li}
              </Typography>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No vision points available
            </Typography>
          )}
        </Box>

        {/* Mission Section */}
        <TextField
          label="Mission Title"
          value={selectedVisionMission.missionTitle}
          margin="dense"
          fullWidth
          variant="outlined"
          InputProps={{ readOnly: true }}
        />

        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2">Mission Points</Typography>
          {selectedVisionMission.missionData?.length > 0 ? (
            selectedVisionMission.missionData.map((item, index) => (
              <Typography key={index} variant="body2">
                • {item.li}
              </Typography>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No mission points available
            </Typography>
          )}
        </Box>
      </>
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={handleCloseViewModal}>Close</Button>
  </DialogActions>
</Dialog>

      </Container>
    </Page>
  );
}
